import React from 'react';
import { render } from 'react-dom';

import BookNowCta from '../react/BookNowCta';

export default class BookNowCtaRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model, abandonBasketApi } = this.context.dataset;
    if (!model || !abandonBasketApi) throw Error('Missing a required dataset');

    let jsonModel;
    try {
      jsonModel = JSON.parse(model);
    } catch (e) {
      jsonModel = undefined;
      console.error('Error parsing labels json: ', model);
    }

    render(<BookNowCta {...jsonModel} abandonBasketApi={abandonBasketApi} />, this.context);
  }
}
